import React from 'react';
import PropTypes from 'prop-types';
import {useTranslate} from '@computerrock/formation-i18n';
import {useStyles} from '@ace-de/ui-components';
import {InputField} from '@ace-de/ui-components/form';
import styles from '../modals/CommunicationModals.module.scss';

const MailFormFields = props => {
    const {cx} = useStyles(props, styles);
    const {mailFormData, onFieldChange, isDisabled} = props;
    const {createTranslateShorthand} = useTranslate();
    const translateModal = createTranslateShorthand('send_message_modal');

    return (
        <>
            <InputField
                className={cx('global!ace-u-margin--bottom-32', 'global!ace-u-full-width')}
                name="street"
                label={translateModal('input_field_label.street')}
                value={mailFormData?.street || ''}
                onChange={value => onFieldChange('street', value)}
                isDisabled={isDisabled}
            />
            <div
                className={cx([
                    'global!ace-u-full-width',
                    'global!ace-u-margin--bottom-32',
                    'global!ace-u-grid',
                ])}
            >
                <InputField
                    className={cx(['global!ace-u-grid-column--span-5'])}
                    name="postCode"
                    label={translateModal('input_field_label.post_code')}
                    value={mailFormData?.postCode || ''}
                    onChange={value => onFieldChange('postCode', value)}
                    isDisabled={isDisabled}
                />
                <InputField
                    className={cx(['global!ace-u-grid-column--span-7'])}
                    name="city"
                    label={translateModal('input_field_label.city')}
                    value={mailFormData?.city || ''}
                    onChange={value => onFieldChange('city', value)}
                    isDisabled={isDisabled}
                />
            </div>
            <InputField
                className={cx('global!ace-u-margin--bottom-32', 'global!ace-u-full-width')}
                name="country"
                label={translateModal('input_field_label.country')}
                value={mailFormData?.country || ''}
                onChange={value => onFieldChange('country', value)}
                isDisabled={isDisabled}
            />
        </>
    );
};

MailFormFields.propTypes = {
    mailFormData: PropTypes.object.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
};

MailFormFields.defaultProps = {
    isDisabled: false,
};

export default MailFormFields;
